<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <div class="column content-box">
      <woot-modal-header :header-title="$t('SURVEY_MGMT.SURVEY.MODAL_HEADER')" />

      <div>
        <div class="main-form">
          <div>
            <span class="span-label">
              <form @submit.prevent="addTable">
                <div v-if="addModel.logoUrl" class="image-preview">
                  <img :src="addModel.logoUrl" alt="Uploaded Image" class="uploaded-image" />
                </div>

                <div class="upload-container">
                  <file-upload class="change-media" accept="image/png,image/gif,image/jpeg"
                    @input-file="onDirectFileUpload($event)">
                    <woot-button class="change-button">{{ $t('SURVEY_MGMT.MODELS.FORM.UPLOAD_PICTURE') }}</woot-button>
                  </file-upload>
                </div>

                <woot-input class="input-text" v-model.trim="addModel.name"
                  :error="$v.addModel.name.$error ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR') : ''"
                  :label="$t('SURVEY_MGMT.MODELS.FORM.NAME')" type="text"
                  :placeholder="$t('SURVEY_MGMT.MODELS.FORM.NAME')" />
                <label>{{ $t('SURVEY_MGMT.MODELS.FORM.DESCRIPTION') }}</label>
                <textarea class="input-text" v-model.trim="addModel.description"
                  :error="$v.addModel.description.$error ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR') : ''"
                  :placeholder="$t('SURVEY_MGMT.MODELS.FORM.DESCRIPTION')" />
                <label>{{ $t('SURVEY_MGMT.MODELS.FORM.GREETINGS') }}</label>
                <textarea class="input-text" v-model.trim="addModel.message"
                  :error="$v.addModel.description.$error ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR') : ''"
                  :placeholder="$t('SURVEY_MGMT.MODELS.FORM.GREETINGS')" />
                <label>{{ $t('SURVEY_MGMT.MODELS.FORM.THANK') }}</label>
                <textarea class="input-text" v-model.trim="addModel.thank_message"
                  :error="$v.addModel.description.$error ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR') : ''"
                  :placeholder="$t('SURVEY_MGMT.MODELS.FORM.THANK')" />
                <label>{{ $t('SURVEY_MGMT.MODELS.FORM.REDIRECT') }}</label>

                <div class="redirect-container">
                  <textarea class="input-text" v-model.trim="addModel.redirect_url"
                    :error="$v.addModel.description.$error ? $t('ATTRIBUTES_MGMT.ADD.FORM.NAME.ERROR') : ''"
                    :placeholder="$t('SURVEY_MGMT.MODELS.FORM.REDIRECT')" />
                  <div class='switch-container'>
                    <woot-switch size="medium" class="auto-offline--switch" v-model.trim="addModel.redirect" />
                  </div>
                </div>
                <div v-for="(question, index) in addModel.questions" :key="index" class="question-container">
                  <woot-input class="input-text question-input" v-model.trim="question.question"
                    :label="`${index + 1}º Pergunta`" type="text" placeholder="Digite a pergunta" />
                  <div class="question-options">
                    <select v-model="question.type" class="question-dropdown"
                      @change="handleQuestionTypeChange(question.type)">
                      <option v-for="type in types" :key="type.type" :value="type.type">
                        {{ $t(`SURVEY_MGMT.MODELS.FORM.TYPES.${type.show}`) }}
                      </option>
                    </select>
                    <label class="question-checkbox">
                      {{ $t('SURVEY_MGMT.MODELS.FORM.REQUIRED') }}
                      <input type="checkbox" v-model="question.required" />
                    </label>
                    <woot-button class="nomargin-button" v-tooltip.top="'Deletar'" variant="smooth" color-scheme="alert"
                      size="small" icon="dismiss-circle" class-names="grey-btn" @click="removeQuestion(index)" />
                  </div>
                </div>
                <div v-if="showRatingAMessages" class="rating-a-messages">
                  <label>{{ $t('SURVEY_MGMT.MODELS.FORM.GOOD_MESSAGE') }}</label>
                  <textarea class="input-text" v-model.trim="addModel.good_message"
                    :placeholder="$t('SURVEY_MGMT.MODELS.FORM.GOOD_MESSAGE')" />
                  <label>{{ $t('SURVEY_MGMT.MODELS.FORM.NEUTRAL_MESSAGE') }}</label>
                  <textarea class="input-text" v-model.trim="addModel.neutral_message"
                    :placeholder="$t('SURVEY_MGMT.MODELS.FORM.NEUTRAL_MESSAGE')" />
                  <label>{{ $t('SURVEY_MGMT.MODELS.FORM.BAD_MESSAGE') }}</label>
                  <textarea class="input-text" v-model.trim="addModel.bad_message"
                    :placeholder="$t('SURVEY_MGMT.MODELS.FORM.BAD_MESSAGE')" />
                </div>
                <woot-button type="button" @click="addQuestion">
                  {{ $t('SURVEY_MGMT.MODELS.FORM.ADD_QUESTION') }}
                </woot-button>
                <woot-button>
                  {{ $t('SURVEY_MGMT.SURVEY.SEND') }}
                </woot-button>
              </form>
            </span>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import { DirectUpload } from 'activestorage';
import {
  buildAccountDirectUploadUrl,
  buildBlobUrl,
} from 'dashboard/helper/directUploadHelper';
import alertMixin from 'shared/mixins/alertMixin';
import { minLength, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import FileUpload from 'vue-upload-component';
import { INPUT_TYPE } from '../constants';
import getUuid from '../../../../../widget/helpers/completeUuid';

export default {
  mixins: [alertMixin],
  components: {
    FileUpload,
  },
  data() {
    return {
      values: [],
      options: [],
      show: true,
      isTouched: false,
      types: INPUT_TYPE,
      showRatingAMessages: false,
      addModel: {
        name: '',
        description: '',
        logoUrl: '',
        questions: [],
        message: '',
        redirect_url: '',
        redirect: false,
        thank_message: '',
        good_message: '',
        neutral_message: '',
        bad_message: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      uiFlags: 'getUIFlags',
      currentUser: 'getCurrentUser',
      indexTab: 'attributes/getIndexTabAttributes',
    }),
  },
  validations: {
    addModel: {
      name: {
        required,
        minLength: minLength(1),
      },
      description: {
        required,
      },
    },
  },
  methods: {
    async onDirectFileUpload(file) {
      if (!file) {
        return;
      }
      const uploadUrl = buildAccountDirectUploadUrl(this.accountId);
      const upload = new DirectUpload(file.file, uploadUrl, {
        directUploadWillCreateBlobWithXHR: xhr => {
          xhr.setRequestHeader('api_access_token', this.currentUser.access_token);
        },
      });

      upload.create(async (error, blob) => {
        if (error) {
          this.showAlert(error);
        } else {
          const fileUrl = buildBlobUrl(blob.signed_id, blob.filename);
          this.addModel.logoUrl = fileUrl;
        }
      });
    },
    onClose() {
      this.$emit('on-close');
    },
    async addTable() {
      try {
        this.uuidValue = getUuid();
        await this.$store.dispatch('customSurveys/createSurvey', {
          smart_surveys: {
            name: this.addModel.name,
            description: this.addModel.description,
            questions: this.addModel.questions,
            logo: this.addModel.logoUrl,
            uuid: this.uuidValue,
            message: this.addModel.message,
            redirect_url: this.addModel.redirect_url,
            redirect: this.addModel.redirect,
            thank_message: this.addModel.thank_message,
            good_message: this.addModel.good_message,
            neutral_message: this.addModel.neutral_message,
            bad_message: this.addModel.bad_message,
            active: true,
            until_date: null
          }
        });
        this.onClose();
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    addQuestion() {
      this.addModel.questions.push({
        question: '',
        type: 'text',
        required: false,
      });
    },
    removeQuestion(index) {
      this.addModel.questions.splice(index, 1);
    },
    handleQuestionTypeChange(type) {
      if (type === 'rating_a' && !this.showRatingAMessages) {
        this.showRatingAMessages = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.redirect-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.upload-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.switch-container {
  display: flex;
  width: 100%;
  padding: 8px;
  height: 100%;
  margin-bottom: 16px;
  max-width: 70px;
}

.uploaded-image {
  max-width: 300px;
  max-height: 100px;
}

.image-preview {
  display: flex;
  justify-content: center;
}

.question-options {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}

.rating-a-messages {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
}
</style>